import { mapActions, mapGetters } from 'vuex'
import { toastFailure } from '@/libs/toastification'
import { formatDashboardDateRange } from '@/libs/dashboardDateRange'
import { normalizeImageUrl } from '@/libs/utils'
import { canStaffViewOtherSupervisorsOrders, canStaffChangeOtherSupervisorsOrders } from '@/libs/staffPermissions'

export default {
  data() {
    return {
      isLoading: false,
      selectedDateRange: null,
      filterSupervisorId: '',
      companyPurpose: window.companyPurpose,
    }
  },
  computed: {
    ...mapGetters({
      authUser: 'auth/user',
      staff: 'staff/staff',
    }),
    formattedDateRange() {
      return formatDashboardDateRange(this.selectedDateRange)
    },
    isCompanyOwner() {
      return this.authUser?.role === 'Company Owner'
    },
    canViewOtherSupervisorsOrders() {
      return canStaffViewOtherSupervisorsOrders(this.authUser)
    },
    canChangeOtherSupervisorsOrders() {
      return canStaffChangeOtherSupervisorsOrders(this.authUser)
    },
    showSupervisorFilter() {
      return this.companyPurpose !== 'rent'
        && (this.isCompanyOwner || this.canViewOtherSupervisorsOrders || this.canChangeOtherSupervisorsOrders)
    },
    supervisorPictureFallback() {
      return normalizeImageUrl('')
    },
    supervisorFilterOptions() {
      return [
        { id: '', name: 'All supervisors', picture: null },
        ...(this.staff || []).map((member) => ({
          id: member.id,
          name: member.name,
          picture: member.picture ?? null,
        })),
      ]
    },
  },
  created() {
    this.ensureStaffLoaded()
  },
  watch: {
    showSupervisorFilter(value) {
      if (value) {
        this.ensureStaffLoaded()
      }
    },
  },
  methods: {
    ...mapActions({
      loadStaff: 'staff/loadStaff',
    }),
    ensureStaffLoaded() {
      if (!this.showSupervisorFilter) {
        return
      }

      this.loadStaff().catch(() => {})
    },
    async onDateRangeChange({ from, to }) {
      this.selectedDateRange = { from, to }
      await this.loadDashboardData(from, to)
    },
    async onSupervisorFilterChange(value) {
      this.filterSupervisorId = value === null || value === undefined ? '' : value
      if (!this.selectedDateRange?.from || !this.selectedDateRange?.to) {
        return
      }
      await this.loadDashboardData(this.selectedDateRange.from, this.selectedDateRange.to)
    },
    async loadDashboardData(from, to) {
      if (!from || !to) {
        return
      }

      this.isLoading = true

      try {
        await this.fetchDashboardData({
          from,
          to,
          supervisor_id: this.showSupervisorFilter && this.filterSupervisorId !== ''
            ? this.filterSupervisorId
            : undefined,
        })
      } catch (error) {
        toastFailure(this.dashboardLoadErrorMessage || 'Can not load dashboard statistics')
      } finally {
        this.isLoading = false
      }
    },
    fetchDashboardData() {
      return Promise.resolve()
    },
  },
}
